import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../../components/ui/button';
import { LogOut, ArrowLeft } from 'lucide-react';
import AuditLogViewer from '../../components/admin/AuditLogViewer';

const AuditLogPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      {/* Top Bar - matching System Owner portal */}
      <header className="bg-primary text-white px-6 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Button variant="ghost" size="sm" className="text-white hover:bg-white/10" onClick={() => navigate('/admin/system')}>
              <ArrowLeft className="w-4 h-4 mr-1" /> Back
            </Button>
            <h1 className="font-serif text-lg font-semibold">Audit Trail</h1>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm">{user?.email}</span>
            <Button variant="ghost" size="sm" className="text-white hover:bg-white/10" onClick={() => { logout(); navigate('/login'); }}>
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </header>

      <main className="px-6 py-6">
        <AuditLogViewer isSystemOwner={true} />
      </main>
    </div>
  );
};

export default AuditLogPage;
